import { createAction, props } from "@ngrx/store";
import { Filter, PagesWithFilters } from "./state";

export const resetFilters = createAction("[Filter] Reset Filters");

export const resetFilter = createAction("[Filter] Reset Filter", props<{ page: PagesWithFilters }>());

export const setFilter = createAction("[Filter] Set Filter", props<{ page: PagesWithFilters; filter: Filter }>());
